<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-flex xs11 sm11 class="text-left">
                        <h3>Import offres Conectis</h3>
                    </v-flex>
                    <v-flex xs12 sm8 offset-sm1>
                        <p align="left">
                            Sélectionnez l'offre PDF à importer 
                            <br><br>
                            <input v-if="!newQuotation" type="file" ref="quotation" accept=".pdf" v-on:change="handleQuotationUpload(1, 'PDF')"/>
                        </p>
                        <v-alert :value="!quotationExtensionOk" type="error">Fichier PDF requis !</v-alert> 
                        <v-alert :value="quotationTooBig" type="error">{{ $store.state.attachment_oversize_text }}</v-alert>
                        <v-alert :value="quotationExists" type="warning">{{ uploadQuotationComment }}</v-alert>
                        <v-flex v-if="$store.state.is_loading">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-flex>
                        <v-flex class="text-xs-center mt-3">
                            <v-alert class="white--text" v-if="api_status === 'offre_importee' && newQuotation" color="success"><h3>{{ uploadQuotationComment }}</h3></v-alert>
                            <v-chip class="white--text" v-if="api_status === 'offre_non-importee'" color="warning"><h3>Erreur ! L'offre n'a pas été importée en base de données</h3></v-chip>
                            <v-chip class="white--text" v-if="axios_error !== ''" color="error"><h3>{{ axios_error }} !</h3></v-chip>
                        </v-flex>
                        <v-card-actions>
                            <v-btn text v-if="quotationOk && !quotationExists && !newQuotation && !$store.state.is_loading && quotationExtensionOk" @click="submitQuotationFile">Importer</v-btn>
                            <v-btn text v-if="quotationExists || !quotationExtensionOk" @click="cancelQuotationImport">Annuler</v-btn>
                        </v-card-actions>
                    </v-flex>	
                    <v-flex xs12 sm8 offset-sm1 v-if="newQuotation">
                        Vous pouvez modifier la référence de l'offre ci-dessous puis valider :
                        <v-text-field
                            v-model=quotationTitle
                            label="Référence de l'offre"
                            :placeholder="quotationTitle"
                            filled
                        ></v-text-field>
                        <v-flex>
                            <a :href="calendarUrlQuotationReminder" target="blank">Ajouter un rappel de suivi</a>
                        </v-flex>
                        <v-flex>
                            <a :href="calendarUrlExpirationReminder" target="blank">Ajouter un rappel à la date d'expiration</a>
                        </v-flex>
                        <v-btn text v-if="newQuotation" @click="quotationImportOk">Valider</v-btn>
                    </v-flex>
                    
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
	import axios from 'axios';

	export default {
		name: "ImportOffresConectis",

		data: function () {
			return {
                axios_error: "",
                newQuotation: false,
				quotationExists: false,
				quotationExtensionOk: true,
				quotationFile: {},
				quotationOk: false,
                quotationTitle: null,
				quotationTooBig: false,
				uploadQuotationComment: "",
				importQuotationResponse: "",
				api_status: "",
				attachment_size: 0,
				quotationNumber: null,
				quotationFileName: null,
				quotationDate: null,
				quotationValidityDate: null,
				quotationDateReminder: null,
                quotationValidityDateReminder: null,
				attachment_oversize: false,
                attachment_oversize_text: "",
				calendarUrl: 'https://calendar.google.com/calendar/r/eventedit?trp=false&src=gigamedia.belgium@gmail.com',
				calendarUrlQuotationReminder: null,
				calendarUrlExpirationReminder: null,
				calendarUrlFollow: null,
            }
        },
		methods: {
			cancelQuotationImport() {
				const input = this.$refs.quotation;
				input.type = "text";
				input.type = "file";
				this.quotationExists = false;
				this.api_status = "";
				this.quotationExtensionOk = true;
			},
			handleQuotationUpload(fileSizeMax, fileExtension) {
				this.quotationFile = this.$refs.quotation.files[0];
				var fileSize = this.quotationFile.size;
				if (this.quotationFile.name.split(".").pop().toUpperCase() == fileExtension) { //check if file extension is ok
					this.fileExtensionOk = true;
					this.quotationOk = true;
				}
				else {
					this.quotationExtensionOk = false;
					this.quotationOk = false;
				}
				if (fileSize > fileSizeMax * 1024 * 1024) { // si taille fichiers > 
					this.quotationTooBig = true;
					this.quotationOk = false;
					this.$store.state.attachment_oversize_text = "Fichier trop volumineux.";
					this.api_status = "";
					return;
				}
				else {
					this.quotationTooBig = false;
					this.quotationOk = true;
					this.api_status = "";
					return;
				}
			},
			quotationImportOk: function () {
				var link = "http://domoserver.ddns.net/gigamedia1/quotationTitleSave.php?title=" + encodeURIComponent(this.quotationTitle) + "&number=" + encodeURIComponent(this.quotationNumber);
				axios.get(link).then(response => (this.quotationTitleSave = response.data));
				this.newQuotation = false;
				const input = this.$refs.quotation;
				input.type = "text";
				input.type = "file";
				this.api_status = "";
			},
			submitQuotationFile() {
				/*
					Initialize the form data
				*/
				let formData = new FormData();
				/*
					Iteate over any file sent over appending the files
					to the form data.
				*/
				formData.append("files[0]", this.quotationFile);
				/*
					Make the request to the POST /multiple-files URL
				*/
				var link = "http://domoserver.ddns.net/gigamedia1/importQuotation.php";
				this.axios_error = "";
				this.axios.post(link, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}).then(response => {
					this.importQuotationResponse = response;
					this.api_status = response.data.api_status;
					this.attachment_size = response.data.attachment_size;
					this.quotationTitle = response.data.QUOTATION_TITLE;
					this.quotationNumber = response.data.QUOTATION_NUMBER;
					this.quotationFileName = response.data.QUOTATION_FILENAME;
					this.quotationDate = response.data.QUOTATION_DATE;
					this.quotationValidityDate = response.data.QUOTATION_VALIDITY_DATE;
					this.quotationDateReminder = response.data.QUOTATION_DATE_REMINDER;
					this.quotationValidityDateReminder = response.data.QUOTATION_VALIDITY_DATE_REMINDER;
					if (response.data.attachment_size > 1024 * 1024) {
						this.attachment_oversize = true;
						this.$store.state.attachment_oversize_text = "Fichier trop volumineux.";
					}
					if (response.data.api_status === "offre_existe") {
						this.quotationExists = true;
						this.uploadQuotationComment = "L'offre existe déjà en base de données.";
					}
					if (response.data.api_status === "offre_importee") {
						this.newQuotation = true;
						this.uploadQuotationComment = "L'offre a été importée en base de données : " + response.data.nombre_articles + " article(s) - total : " + response.data.montant_total + " €";
					}
					this.calendarUrlQuotationReminder = this.calendarUrl + "&text=Offre+" + this.quotationNumber + "+" + this.quotationTitle + "&location=ggm+Belgium&details=Rappel+:+l'offre+" + this.quotationNumber + "+" + this.quotationTitle + "+a+été+reçue+le+" + this.quotationDate + ".+Merci+de+contacter+le+client+SVP+!&add=" + this.authEmail + "&dates=" + this.quotationDateReminder + "T070000Z/" + this.quotationDateReminder + "T080000Z&sf=true";
					this.calendarUrlExpirationReminder = this.calendarUrl + "&text=Offre+" + this.quotationNumber + "+" + this.quotationTitle + "&location=ggm+Belgium&details=Rappel+:+l'offre+" + this.quotationNumber + "+" + this.quotationTitle + "+arrive+à+expiration.&add=" + this.authEmail + "&dates=" + this.quotationValidityDateReminder + "T070000Z/" + this.quotationValidityDateReminder + "T080000Z&sf=true";
					link = "http://domoserver.ddns.net/gigamedia1/XlsxWriter/quotationXlsx.php?quotationFileName=" + encodeURIComponent(this.quotationFileName);
					axios.get(link).then(response => (this.dataXlsx = response.data));
					link = "http://domoserver.ddns.net/gigamedia1/loadQuotations.php";
					axios.get(link).then(response => (this.$store.state.quotations = response.data));
					link = "http://domoserver.ddns.net/gigamedia1/loadProjects.php";
					axios.get(link).then(response => (this.$store.state.projects = response.data));
					this.axios_error = "";
				}).catch((error) => {
					this.axios_error = error;
				});
			},
        }
    }
</script>
